export const Modal = {
  ADD_PROJECT_USERS: 'ADD_PROJECT_USERS',
  ADD_TO_REPORT: 'ADD_TO_REPORT',
  CANCEL_PREMIUM_SAMPLE_MODAL: 'CANCEL_PREMIUM_SAMPLE_MODAL',
  CANCEL_SAMPLE_MODAL: 'CANCEL_SAMPLE_MODAL',
  COMPANY_DASHBOARD_MODAL: 'COMPANY_DASHBOARD_MODAL',
  COMPANY_DOCUMENTS_MODAL: 'COMPANY_DOCUMENTS_MODAL',
  CONFIRMATION: 'CONFIRMATION',
  CREATE_REPORT: 'CREATE_REPORT',
  CREATE_REPORT_FROM_TEMPLATE: 'CREATE_REPORT_FROM_TEMPLATE',
  DELETE_PHOTOS: 'DELETE_PHOTOS',
  DOCUMENT_UPLOAD_MODAL: 'DOCUMENT_UPLOAD_MODAL',
  EDIT_REPORT_TEMPLATE: 'EDIT_REPORT_TEMPLATE',
  END_COLLABORATION_CONFIRM: 'END_COLLABORATION_CONFIRM',
  MESSAGE_MODAL: 'MESSAGE_MODAL',
  PAGES_VIDEO_MODAL: 'PAGES_VIDEO_MODAL',
  PAYMENT_REQUEST_MODAL: 'PAYMENT_REQUEST_MODAL',
  PAYMENT_REQUEST_V2_MODAL: 'PAYMENT_REQUEST_V2_MODAL',
  PAYMENTS_VALUE_PROPS_MODAL: 'PAYMENTS_VALUE_PROPS_MODAL',
  PREMIUM_SAMPLE_MODAL: 'PREMIUM_SAMPLE_MODAL',
  PROJECT_TRASH_CAN: 'PROJECT_TRASH_CAN',
  PROJECT_USERS: 'PROJECT_USERS',
  PUBLISH_WIZARD: 'PUBLISH_WIZARD',
  REFERRAL_MODAL: 'REFERRAL_MODAL',
  REFERENCE_PHOTOS_MODAL: 'REFERENCE_PHOTOS_MODAL',
  REARRANGE_REPORT_ITEMS: 'REARRANGE_REPORT_ITEMS',
  RESTRICTED_FEATURE_MODAL: 'RESTRICTED_FEATURE_MODAL',
  SEND_TO_QUICKBOOKS: 'SEND_TO_QUICKBOOKS',
  SET_A_REMINDER: 'SET_A_REMINDER',
  SHOWCASE_SETUP_GUIDE: 'SHOWCASE_SETUP_GUIDE',
  TEMPLATES_MODAL: 'TEMPLATES_MODAL',
  TASK_LIST_FORM_MODAL: 'TASK_LIST_FORM_MODAL',
  TRUSTY_HYPE_MODAL: 'TRUSTY_HYPE_MODAL',
  TRUSTY_VALUE_PROPS_MODAL: 'TRUSTY_VALUE_PROPS_MODAL',
  UPGRADE_BEFORE_AFTER: 'UPGRADE_BEFORE_AFTER',
  UPGRADE_COLLAB_CHECKLISTS: 'UPGRADE_COLLAB_CHECKLISTS',
  UPGRADE_GALLERY_LINKS: 'UPGRADE_GALLERY_LINKS',
  UPGRADE_PROJECT_COLLABORATION: 'UPGRADE_PROJECT_COLLABORATION',
  UPGRADE_REPORTS: 'UPGRADE_REPORTS',
  UPGRADE_TASK_LIST_ASSIGN_MODAL: 'UPGRADE_TASK_LIST_ASSIGN_MODAL',
  UPGRADE_TIMELINE_LINKS: 'UPGRADE_TIMELINE_LINKS',
  UPGRADE_TODOS: 'UPGRADE_TODOS',
  UPLOAD_COMPANY_DOCUMENT_MODAL: 'UPLOAD_COMPANY_DOCUMENT_MODAL',
  SHOWCASE_WIZARD: 'SHOWCASE_WIZARD',
  WATCH_DEMO_MODAL: 'WATCH_DEMO_MODAL',
  STRIPE_PAYMENT_MODAL: 'STRIPE_PAYMENT_MODAL',
  USE_PAGE_TEMPLATE_MODAL: 'USE_PAGE_TEMPLATE_MODAL',
  CREATE_REVIEW_PROFILE_MODAL: 'CREATE_REVIEW_PROFILE_MODAL',
  SHARE_MODAL: 'SHARE_MODAL',
  SAVE_PAGE_AS_TEMPLATE_MODAL: 'SAVE_PAGE_AS_TEMPLATE_MODAL',
  SIGNATURES_PROMO: 'SIGNATURES_PROMO',
  CREATE_PUBLIC_PROFILE: 'CREATE_PUBLIC_PROFILE',
  EDIT_PUBLIC_PROFILE: 'EDIT_PUBLIC_PROFILE',
  SHOWCASE_WIDGET_PROMO: 'SHOWCASE_WIDGET_PROMO',
  EDIT_REVIEW_PROFILE_NICKNAME_MODAL: 'EDIT_REVIEW_PROFILE_NICKNAME_MODAL',
  DELETE_REVIEW_PROFILE_MODAL: 'DELETE_REVIEW_PROFILE_MODAL',
  EXPORT_PAGE_PDF_MODAL: 'EXPORT_PAGE_PDF_MODAL',
  PAGE_TEMPLATE_PAYWALL: 'PAGE_TEMPLATE_PAYWALL',
  REVIEW_REQUEST_MODAL: 'REVIEW_REQUEST_MODAL',
  REVIEW_REQUEST_VIDEO_MODAL: 'REVIEW_REQUEST_VIDEO_MODAL',
  SELECT_SHOWCASE_PROJECT: 'SELECT_SHOWCASE_PROJECT',
  PAGE_ASSET_PICKER_MODAL: 'PAGE_ASSET_PICKER_MODAL',
  SAMPLES_UPGRADE_MODAL: 'SAMPLES_UPGRADE_MODAL',
  REVIEWS_UPGRADE_MODAL: 'REVIEWS_UPGRADE_MODAL',
  MAP_EMBED_WIZARD: 'MAP_EMBED_WIZARD',
  MAP_EMBED_PROMO: 'MAP_EMBED_PROMO',
} as const;
